import { TimestampBased } from "./system.models";


export class UserModel {
  id: number;             // Unique identifier for the user.
  firstname: string;      // First name of the user.
  lastname: string;       // Last name of the user.
  username: string;       // Username of the user.
  phone: string;
  email: string;          // Email address of the user.
  avatar: string;         // URL to the user's avatar image.
  
}


export class UserProfile extends UserModel {
  projects: ProjectItem[];    // List of spaces the user is part of.
}


// Contact Model

export class ContactItem extends UserModel {

}


export enum ProjectItemTypeEnum {
  FICTION = 'fiction',
  NONFICTION = 'non-fiction',
}

export class ProjectItem extends TimestampBased {
  id: number;            // Unique identifier for the space.
  title: string;
  thumbnail?: string;          // Name of the space.
  type?: ProjectItemTypeEnum;
  description?: string;   // Description of the space (optional).
  members?: UserModel[];     // List of usernames or email addresses of users who are part of the space.
  outline?: OutlineItem[]; // List of wallets within the space.
  
}


export enum OutlineItemTypeEnum {
  FOLDER = 'folder',
  CHAPTER = 'chapter',
}
export class OutlineItem extends TimestampBased {
  id?: number;               // Unique identifier for the wallet.
  // parent_id?: number;             // Name of the wallet, e.g., "Credit Card #1", "Home Locker."
  parent?: OutlineItem
  title: string;
  body?: string;      // Description of the wallet (optional).
  children?: OutlineItem[];    // List of wallets within the wallet.
  type?: OutlineItemTypeEnum;
}

export class OutlineItemForAi extends OutlineItem {
  writing?: 'title' | null;
  override children?: OutlineItemForAi[];
}



export class TransactionItem {
  id: number;              // Unique identifier for the transaction.
  title: string;
  amount: MoneyModel;          // The numerical value of the transaction amount.
  currency: CurrencyModel; // The currency used for this transaction (reference to the CurrencyModel class).
  wallet: OutlineItem;
  type: TransactionTypeEnum;   // The type of the transaction (Income, Outcome, Debit).
  date: Date;              // The date of the transaction.
  time: string;            // The time of the transaction (optional).
  description: string;     // Description of the transaction (optional).
  category: CategoryItem;
  contact: ContactItem;         // Optional contact person associated with the transaction (for debit transactions).
}

export enum TransactionTypeEnum {
  income = 'income',
  expense = 'expense',
  debt = 'debt',
  credit = 'credit'
}


export class ListItem {
  label: string;
  tooltip?: string;
  slug?: string;
}


// MoneyModel represents a transaction amount with its currency information.
export class MoneyModel {
  value: number;         // The numerical value of the transaction amount.
  currency: CurrencyModel; // The currency used for the transaction.

  constructor(value: number, currency: CurrencyModel) {
    this.value = value;
    this.currency = currency;
  }
}

// CurrencyModel represents information about a specific currency.
export class CurrencyModel {
  id: number;             // Unique identifier for the currency (e.g., 1, 2, 3, ...).
  name: string
  symbol: string;         // The currency symbol (e.g., "$" for USD, "£" for GBP).
  code: string;           // The currency code (e.g., "USD" for US Dollar, "GBP" for British Pound).
  conversionRate: number; // The conversion rate relative to the app's base currency (e.g., USD as the base currency).

  constructor(id: number, symbol: string, code: string, conversionRate: number) {
    this.id = id;
    this.symbol = symbol;
    this.code = code;
    this.conversionRate = conversionRate;
  }
}



// Category Model

export class CategoryItem {
  createdAt: string;
  updatedAt: string;
  id: number;
  name: string;
  logo: string | null;
  priority: string;
  parentId: number | null;
  isGlobal: boolean;
  children: CategoryItem[];
}



